import { Badge } from '~/components/ui/badge';

type CompetencyBadgeProps = {
  name: string;
};

export function CompetencyBadge({ name }: CompetencyBadgeProps): React.ReactNode {
  return (
    <Badge variant="secondary" className="text-xs font-normal capitalize">
      {name}
    </Badge>
  );
}
